import moment from 'moment';
import { capitalize } from '../../../../utils/string';
import { minimizeArrays } from '../../../../utils/array';

/**
 * @param {Object[]} employeeIds
 * @param {Object} shifts
 * @param {Object} rooms
 * @param {Object} attendance
 * @param {Object} ratios
 * @returns {Array[String[]]}
 */
const generateRoomViewHTMLTableRows = (employeeIds, shiftsGroupedByDay, rooms, attendance, ratios) => {
  let rows = [];
  let _rooms = { ...rooms };

  // add 'Unassigned' / 'Floats' to the rooms object
  _rooms[0] = 'Floats';

  Object.keys(_rooms).forEach(roomId => {
    let roomRowGroup = [];
    let roomHeaderRow = [];
    const roomName = roomId !== 0 ? capitalize(_rooms[roomId]) : 'Floats';
    let attendanceForRoom = attendance[roomId];

    if (attendanceForRoom) {
      // remove the weekend
      delete attendanceForRoom['sunday'];
      delete attendanceForRoom['saturday'];
      let formattedAttendance = Object.values(attendanceForRoom).map(v => `Projected: ${v.am}AM / ${v.pm}PM`);
      let ratio = '';

      // if a room has a ratio, add it to the column with the room name
      if (ratios[roomId]) {
        ratio = `(1:${ratios[roomId]})`;
      }

      roomHeaderRow = [
        `${roomName} ${ratio}`,
        ...formattedAttendance
      ];
    } else {
      // filler columns if attendance couldn't be found
      roomHeaderRow = [`${roomName}`, '', '', '', '', ''];
    }

    roomRowGroup.push(roomHeaderRow);

    let employeeRows = [];
    // add employee rows for room
    Object.keys(shiftsGroupedByDay).forEach((dayOfWeek, index) => {
      // plus 1 since the first column is exclusively for the room name and "Monday" is column 2
      const indexToInsertAt = index + 1;
      const shiftsByRoom = shiftsGroupedByDay[dayOfWeek];
      const shiftsForDayInRoom = shiftsByRoom[roomId];

      if (shiftsForDayInRoom.length) {
        shiftsForDayInRoom.forEach(employeeShift => {
          let employeeRow = ['', '', '', '', '', ''];
          const { employeeId, start, end } = employeeShift;
          const employeeInfo = employeeIds[parseInt(employeeId, 10)];

          // this shift is associated with an employee that is "deleted" in Kangarootime, don't include in export
          if (!employeeInfo) {
            return;
          }

          const employeeName = employeeInfo.name;
          const formattedStart = moment(start).format('h:mm a');
          const formattedEnd = moment(end).format('h:mm a');
          const str = `${employeeName}: ${formattedStart}-${formattedEnd}`;

          employeeRow[indexToInsertAt] = str;
          employeeRows.push(employeeRow);
        });
      }
    });

    if (employeeRows.length > 1) {
      employeeRows = minimizeArrays(employeeRows, '');
    }

    if (employeeRows.length === 0) {
      roomRowGroup.push(['', '', '', '', '', '']);
    } else {
      roomRowGroup = roomRowGroup.concat(employeeRows);
    }

    rows = rows.concat(roomRowGroup);
  });

  return rows;
};

export default generateRoomViewHTMLTableRows;
